<template>
  <div class="uk-grid">
    <portal to="entry_header">
      <h1>Contact Details</h1> <small>(Billing address if making a payment)</small>
    </portal>
    <div class="uk-width-1-1">
      <input-row
        v-model="$v.form.address.$model"
        :label="$t('events.address_label')"
        name="address"
        :disabled="disabled"
        :error-message="formError('address', 'required')"
        @input="emitFormInput"
      />
    </div>
    <div class="uk-width-1-1">
      <input-row
        v-model="form.address_2"
        name="address_2"
        :disabled="disabled"
        @input="emitFormInput"
      />
    </div>

    <div class="uk-width-1-1 uk-grid-margin">
      <input-row
        v-model="$v.form.city.$model"
        :label="$t('events.city_label')"
        name="city"
        :disabled="disabled"
        :error-message="formError('city', 'required')"
        @input="emitFormInput"
      />
    </div>
    <div class="uk-width-1-2 uk-grid-margin">
      <input-row
        v-model="$v.form.state.$model"
        :label="$t('events.state_label')"
        name="state"
        :disabled="disabled"
        :error-message="formError('state', 'required')"
        @input="emitFormInput"
      />
    </div>
    <div class="uk-width-1-2 uk-grid-margin">
      <input-row
        v-model="$v.form.zipcode.$model"
        :label="$t('events.zipcode_label')"
        name="zipcode"
        :disabled="disabled"
        :error-message="formError('zipcode', 'required')"
        @input="emitFormInput"
      />
    </div>

    <div class="uk-width-1-1 uk-grid-margin">
      <SelectRow
        v-model="$v.form.purchaser_country.$model"
        :options="countryOptions"
        name="purchaser_country"
        :label="$t('events.entry_country_label')"
        :error-message="formError('purchaser_country', 'required')"
        :disabled="disabled"
        @input="emitFormInput"
      />
    </div>
  </div>
</template>

<script lang="ts">
import input from "../form/input-row.vue";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FormStep from './FormStep';
import SelectRow from "../form/select-row.vue";
import { validationMixin } from "vuelidate";
import { required } from 'vuelidate/lib/validators';
import UserModel from "../../models/UserModel";

@Component({
  components: {
    'input-row': input,
    SelectRow,
  },
  mixins: [validationMixin],
  validations: {
    form: {
      address: {
        required
      },
      city: {
        required
      },
      zipcode: {
        required
      },
      state: {
        required
      },
      purchaser_country: {
        required
      }
    }
  }
})
export default class AddressDetailsStep extends FormStep {
  @Prop() readonly value!: AddressDetails;

  form: AddressDetails = {
    address: '',
    address_2: '',
    city: '',
    zipcode: '',
    state: '',
    purchaser_country: '',
  }

  user!: UserModel;

  created(): void {
    this.$store.dispatch('countries/fetchOptions').then(() => {
      if (this.form.purchaser_country === '' && this.$store.getters['countries/guess']) {
        Vue.set(this.form, 'purchaser_country', this.$store.getters['countries/guess'].code);
        this.emitFormInput();
      }
    });
  }

  mounted(): void {
    if (!this.form.city) {
      this.form.city = this.user.data.city;
    }
    if (!this.form.zipcode) {
      this.form.zipcode = this.user.data.zipcode;
    }
    if (!this.form.purchaser_country) {
      this.form.purchaser_country = this.user.data.country;
    }
  }

  data(): any {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
    }
  }

  get countryOptions(): { value: string, label: string}[] {
    const countries = this.$store.getters['countries/options'];
    const options = [];
    for (const i in countries) {
      options.push({
        value: i,
        label: countries[i],
      })
    }

    return options;
  }

  @Watch('value', {immediate: true, deep: true})
  valuePropUpdated(v: StudentDetails): void {
    this.form = JSON.parse(JSON.stringify(v));
  }

  emitFormInput(): void {
    this.$emit('input', this.form);
  }
}
</script>

<style scoped>

</style>
